<ng-container *ngIf="{
    row: columnData | async,
    keyname: keyName | async,
    is_clickable: isClickable | async
  } as $">
<span *ngIf="$.row && $.keyname" [ngClass]="{'cursor-pointer': $.is_clickable}" (click)="$.is_clickable ? openWriteOffModal('openWriteOffList', $.row) : null" >{{$.row[$.keyname] | currencyformat}}</span>
</ng-container>